/*
 * @Description: 
 * @Version: 1.0
 * @Autor: zhangle
 * @Date: 2022-03-16 13:43:35
 * @LastEditors: zhangle
 * @LastEditTime: 2023-02-23 14:30:51
 */
import TsaSignPassword from '@/components/signPassword/index.vue'
let $vm
let watcher
let watcher1
const plugin = {
  install (vue, pluginOptions = {}) {
    const SignPassword = vue.extend(TsaSignPassword)
    if (!$vm) {
      $vm = new SignPassword({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const signPassword = {
      show (options = {}) {
        watcher && watcher()
        watcher = $vm.$watch('statusConfirm', (val) => {
          val && options.onConfirm && options.onConfirm($vm.value, $vm.timeStamp)
        })
        watcher1 && watcher1()
        watcher1 = $vm.$watch('statusRead', (val) => {
          val && options.onRead && options.onRead($vm.value, $vm.timeStamp)
        })
        $vm.show = true
        Object.keys(options).map(key => {
          $vm[key] = options[key]
        })
      },
      checked () {
        $vm.checked = true
        $vm.timeStamp = new Date().getTime()
      },
      hide () {
        $vm.show = false
      }
    }
    if (!vue.prototype.$TsaSignPassword) {
      vue.prototype.$TsaSignPassword = signPassword
    }
  }
}

export default plugin



// WEBPACK FOOTER //
// ./src/plugins/signPassword/index.js